import * as Setting from "../Setting";
import {convertJalaliToGregorian, dataToEnglishCharacters} from "../utils/datetime";
import {authConfig} from "./Auth";
import {oAuthParamsToQuery} from "./AuthBackend";

export async function rsoSmartLogin(stepData = {}, additionalData = {}, stateId = "", applicationName = "app-built-in", organizationName = "built-in", protocolType = "login", oauthParams = {}, serviceUrl = "", delegatedAccount = "", signinMethod = "", code = "", state = "", redirectUri = "", method = "", codeVerifier = "", samlRequest = "", providerName = "") {
  // eslint-disable-next-line no-useless-catch
  try {
    const processedStepData = {...stepData};

    Object.keys(processedStepData).forEach(key => {
      if (key.startsWith("is_")) {
        const value = processedStepData[key];
        if (value === "on") {
          processedStepData[key] = true;
        } else if (value === "true" || value === true) {
          processedStepData[key] = true;
        } else {
          processedStepData[key] = false;
        }
      }
    });
    if (processedStepData.birthdate) {
      const jalaliDate = processedStepData.birthdate;
      const gregorianDate = convertJalaliToGregorian(jalaliDate);
      console.log("gregorianDate: ", gregorianDate, " type: ", typeof gregorianDate);
      if (gregorianDate) {
        processedStepData.jalali_birthdate = dataToEnglishCharacters(jalaliDate);
        processedStepData.birthdate = gregorianDate;
      }

      console.log("processedStepData: ", processedStepData);
    }
    const defaultData = {
      application: applicationName,
      organization: organizationName,
      autoSignin: true,
      language: "",
      signinMethod: signinMethod ?? "Password",
      username: stepData.identifier,
      type: protocolType,
      smartLogin: true,
      stepData: {...processedStepData},
      stateId: stateId,
      state: state,
      code: code,
      redirectUri: redirectUri,
      method: method,
      codeVerifier: codeVerifier, // Include PKCE code verifier
      samlRequest: samlRequest,
      provider: providerName,
    };

    const data = {
      ...defaultData,
      ...additionalData,
      stepData: {
        ...defaultData.stepData,
        ...processedStepData,
      },
      ...(delegatedAccount && {stateId: stateId}),
      ...(delegatedAccount && {DelegationOriginalUser: delegatedAccount}),
    };

    if (data.stepData?.phone) {
      data.stepData.phone = data.stepData.phone.toString().replace(/^(?:\+98|0098|0)/, "");
    }

    // Determine login url based on the protocol type (cas, oauth)
    let smartLoginAuthBackendUrl;
    switch (protocolType) {
    case "cas":
      const urlObj = new URL(`${Setting.ServerUrl}/api/login`);
      urlObj.searchParams.set("service", serviceUrl);
      console.log(`smart login cas service url is: ${urlObj.toString()}`);
      smartLoginAuthBackendUrl = urlObj.toString();
      break;

    case "code":
      smartLoginAuthBackendUrl = `${Setting.ServerUrl}/api/login${oAuthParamsToQuery(oauthParams)}`;
      break;

    default:
      smartLoginAuthBackendUrl = `${Setting.ServerUrl}/api/login`;
    }

    const response = await fetch(smartLoginAuthBackendUrl, {
      method: "POST",
      credentials: "include",
      headers: {
        "Accept-Language": Setting.getAcceptLanguage(),
      },
      body: JSON.stringify(data),
    });
    // error handling
    // if (!response.ok) {
    //   console.log("response", response);
    //   await response.json().catch(() => ({}));
    //   throw new Error(`Server error: ${response.message}`);
    // }

    return await response.json();
  } catch (error) {
    throw error;
  }
}

export function GetSmartLoginFlow(organization, application) {// FIXME: fill the application in state and also send the flow type
  const appCondition = application !== null ? `application=${application}` : "";
  return fetch(`${authConfig.serverUrl}/api/get-smart-login-flow?organization=${organization}&${appCondition}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => res.json());
}
export function GetNationalIds(application, organization) {
  return fetch(`${authConfig.serverUrl}/api/get-rso-national-ids-whitelist?application=${application}&organization=${organization}&applicationSpecific=true`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => res.json());
}
export function DeleteNationalIds(nationalId, application, organization) {
  return fetch(`${authConfig.serverUrl}/api/delete-rso-national-ids-whitelist?application=${application}&organization=${organization}&applicationSpecific=true`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(nationalId),
  }).then(res => res.json());
}
export function CreateNationalIds(data, application, organization) {
  return fetch(`${authConfig.serverUrl}/api/add-rso-national-ids-whitelist?application=${application}&organization=${organization}&applicationSpecific=true`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then(res => res.json());
}
export function EditNationalIds(data, application, organization) {
  return fetch(`${authConfig.serverUrl}/api/update-rso-national-ids-whitelist?application=${application}&organization=${organization}&applicationSpecific=true`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then(res => res.json());
}

export function UpdateSmartLoginFlow(organization, owner, application, flow_type, flow) {
  const appCondition = application !== null ? `application=${application}&` : "";
  return fetch(`${authConfig.serverUrl}/api/update-smart-login-flow?organization=${organization}&owner=${owner}&${appCondition}flow_type=${flow_type}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(flow),
  }).then(async res => {
    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || `HTTP ${res.status}`);
    }
    return res.json();
  });
}
export function getDefaultStepList(organization, application) {
  return fetch(`${authConfig.serverUrl}/api/get-default-smart-login-flow?organization=${organization}&application=${application}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => res.json());
}
export function AddStepSmartLoginFlow(organization, owner, application, flow_type, flow) {
  return fetch(`${authConfig.serverUrl}/api/add-smart-login-step?owner=${owner}&flow_type=${flow_type}&application=${application}&organization=${organization}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(flow),
  }).then(res => res.json());
}

export function CopySmartLoginFlow(sourceOrg, destApp) {
  return fetch(`${authConfig.serverUrl}/api/copy-flows?source_org=${sourceOrg}&dest_app=${destApp}&flow_type=global`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  }).then(res => res.json());
}
